<template>
  <v-container class="pa-4">
    <v-row>
      <v-col
        cols="6"
        md="6"
        sm="6"
      >
        <h2>請求書一覧</h2>
      </v-col>
      <v-col
        cols="6"
        md="6"
        sm="6"
        class="text-right"
      >
        <v-btn
          :to="{ name: 'CreateAdsInvoice' }"
          class="title-btn red white--text"
        >
          新規登録
        </v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="2"
      >
        <v-text-field
          label="請求書番号"
          dense
          v-model="params.cd"
          @change="getAdsInvoices"
        >
        </v-text-field>
      </v-col>
      <v-col
        cols="2"
      >
        <v-text-field
          label="顧客"
          dense
          v-model="params.search"
          @change="getAdsInvoices"
        >
        </v-text-field>
      </v-col>
      <v-col
        cols="2"
      >
        <v-select
          label="ステータス"
          dense
          :items="$store.getters.adsInvoiceStatus"
          item-text="name"
          item-value="id"
          v-model="params.status"
          @change="getAdsInvoices"
        >
        </v-select>
      </v-col>
      <v-col
        cols="2"
      >
        <v-menu
          :close-on-content-click="false"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
          max-width="290px"
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              label="請求日（FROM）"
              dense
              readonly
              v-on="on"
              v-model="params.date_of_issue__gte"
            ></v-text-field>
          </template>
          <v-date-picker
            locale="ja"
            no-title
            @input="fromDateMenu = false"
            v-model="params.date_of_issue__gte"
            @change="getAdsInvoices"
          ></v-date-picker>
        </v-menu>
      </v-col>
      <v-col
        cols="2"
      >
        <v-menu
          :close-on-content-click="false"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
          max-width="290px"
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              label="請求日（TO）"
              dense
              readonly
              v-on="on"
              v-model="params.date_of_issue__lte"
            ></v-text-field>
          </template>
          <v-date-picker
            locale="ja"
            no-title
            @input="fromDateMenu = false"
            v-model="params.date_of_issue__lte"
            @change="getAdsInvoices"
          ></v-date-picker>
        </v-menu>
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="4"
      >
        <v-btn
          class="title-btn mr-4"
          @click="download_dialog = true"
        >
          データダウンロード
        </v-btn>
        <v-dialog v-model="download_dialog" persistent>
          <v-card>
            <v-card-title>
              データダウンロード
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col
                    cols="12"
                    sm="6"
                    md="6"
                  >
                    <v-select
                      label="入金状態"
                      dense
                      :items=payment_status_list
                      item-text="name"
                      item-value="id"
                      v-model="params.download_payment_status"
                    >
                    </v-select>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col
                    cols="12"
                    md="2"
                    sm="6"
                  >
                  <v-btn
                    @click="data_download"
                    class="white--text red"
                    >ダウンロード</v-btn>
                  </v-col>
                  <v-col
                    cols="12"
                    md="2"
                    sm="6"
                  >
                  <v-btn
                    @click="download_dialog = false"
                    color="default">キャンセル</v-btn>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
          </v-card>
        </v-dialog>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-data-table
          :headers="headers"
          :items="items"
          :server-items-length="item_total"
          :loading="loading"
          :options.sync="options"
          :footer-props="footer_props"
          disable-sort
          disable-filtering
          locale="ja-jp"
          loading-text="読込中"
          no-data-text="データがありません。"
          @update:options="getAdsInvoices"
        >
        <template v-slot:item.action="{ item }">
          <v-btn
            small
            color="default"
            :to="{ name: 'EditAdsInvoice', params: {id: item.id}}"
          >
            詳細
          </v-btn>
          <v-menu
            bottom
            left
          >
            <template v-slot:activator="{ on }">
              <v-btn
                icon
                class="ml-2"
                v-on="on"
              >
                <v-icon>mdi-dots-vertical</v-icon>
              </v-btn>
            </template>

            <v-list>
              <v-list-item
                dense
                @click="deleteConfirm(item)"
              >
                <v-list-item-title>削除する</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </template>
        </v-data-table>
        <confirm-dialog
          ref="confirm"
          title="請求書削除"
          message="請求書を削除してもいいですか？"
          buttonMessage="削除"
          @confirm="deleteAdsInvoice"
        >
        </confirm-dialog>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import ConfirmDialog from '@/components/ConfirmDialog'

export default {
  components: {
    'confirm-dialog': ConfirmDialog,
  },
  data() {
    return {
      items: [],
      params: {
        cd: '',
        search: '',
        status: '',
        date_of_issue__lte: '',
        date_of_issue__gte: '',
        download_payment_status: '',
      },
      loading: false,
      item_total: 0,
      options: {
        itemsPerPage: 20,
      },
      search_products: [],
      search_productdetails: [],
      footer_props: {
        'items-per-page-options': [],
        'items-per-page-text': null,
        'disable-items-per-page': true,
      },
      headers: [
        {text: "顧客コード", value: "client.cd"},
        {text: "顧客名称", value: "client.name_combined"},
        {text: "電話番号", value: "client.tel"},
        {text: "金額", value: "sum_price"},
        {text: "ステータス", value: "status.name"},
        {text: "操作", value: "action", width: "130px"},
      ],
      deleteItem: {},
      download_dialog: false,
      payment_status_list: [
        {id: 1, name: 'すべて'},
        {id: 2, name: '対象期間以前に入金あり'},
        {id: 3, name: '対象期間以前に入金なし'},
      ],
    };
  },
  methods: {
    async getAdsInvoices() {
      this.loading = true;
      try {
        this.params.page = this.options.page;
        let response = await this.$axios.get(
          `${process.env.VUE_APP_API_URL_BASE}/api/ads/adsinvoices/`,
          {
            params: this.params,
            headers: {
              Authorization: `JWT ${this.$store.getters.token}`,
            },
          },
        );
        this.item_total = response.data.count
        this.items = response.data.results
        this.loading = false;
      } catch(error) {
        const error_status = error.response.status;
        if (error_status == 401) {
          this.$store.dispatch('userLogout');
        }
        this.loading = false;
      }
    },
    deleteConfirm(item) {
      this.deleteItem = item;
      this.$refs.confirm.open();
    },
    async deleteAdsInvoice() {
      try {
        await this.$axios.delete(
          `${process.env.VUE_APP_API_URL_BASE}/api/ads/adsinvoices/${this.deleteItem.id}/`,
          {
            headers: {
              Authorization: `JWT ${this.$store.getters.token}`,
            },
          },
        );
        this.$store.dispatch('setSnackbar', {message: "削除されました", type: "success"});
        await this.getInvoices();
      } catch(error) {
        const error_status = error.response.status;
        if (error_status == 401) {
          this.$store.dispatch('userLogout');
        }
        this.$store.dispatch('setSnackbar', {message: "削除できませんでした", type: "error"});
      }
    },
    async data_download() {
      try {
        const response = await this.$axios.get(
          `${process.env.VUE_APP_API_URL_BASE}/api/ads/adsinvoices/list_download/`,
          {
            params: this.params,
            responseType: "blob",
            headers: {
              Authorization: `JWT ${this.$store.getters.token}`,
            },
          },
        );
        const url = URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "invoice_list.xlsx");
        document.body.appendChild(link);
        link.click();
        URL.revokeObjectURL(url);
        link.parentNode.removeChild(link);
        this.download_dialog = false;
      } catch(error) {
        const error_status = error.response.status;
        if (error_status == 401) {
          this.$store.dispatch('userLogout');
        }
        this.$store.dispatch('setSnackbar', {message: "取得できませんでした", type: "error"});
      }
    },
  }
}
</script>